document.addEventListener("DOMContentLoaded", () => {
    const sliders = document.querySelectorAll(".collection-list-swiper");

    sliders.forEach((swiperEl) => {
        const desktopCols = parseInt(swiperEl.dataset.columnsDesktop);
        const mobileCols = parseInt(swiperEl.dataset.columnsMobile);

        const gapMobile = parseInt(swiperEl.dataset.gapMobile);
        const gapDesktop = parseInt(swiperEl.dataset.gapDesktop);

        new Swiper(swiperEl, {
            slidesPerView: mobileCols,
            spaceBetween: gapMobile,
            loop: false,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            navigation: {
                nextEl: swiperEl.querySelector(".swiper-btn--next"),
                prevEl: swiperEl.querySelector(".swiper-btn--prev"),
            },
            breakpoints: {
                750: {
                    slidesPerView: desktopCols - 1,
                    spaceBetween: 20,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0
                },
                890: {
                    slidesPerView: desktopCols,
                    spaceBetween: gapDesktop
                },
            },
        });
    });
});
